import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { setShowArtistsOverview } from '../../../../redux/reducers/notificationModals';
import handleNotifications from '../utils/helpers';

import AllEventsList from './EventList';
import Box from 'components/elements/Box';
import SearchField from 'components/styled/SearchField/SearchField';
import Button from '../../../elements/button';
import ActivityDropdown from './ActivityDropdown';

import { ReactComponent as SettingsIcon } from 'icons/icon-notification-settings.svg';

import { CaretBack } from 'components/TopicFilters/ViewRelatedMenu/ViewRelatedMenu.styles';
import {
  TimeHeading,
  BackButton,
  Artwork,
  Flex,
  ArtistWrapper,
  Scroll,
  NoDataMessage,
  SearchFieldWrapper,
} from '../styles';

import { IEventData, IEvent, IGroupedEvents, IMetadata } from '../types';
import { ILabelValuePair } from 'types/shared';

const AllEvents: React.FC<IProps> = (props) => {
  const {
    groupedAllEvents,
    unreadEvents,
    totalEvents,
    countries,
    entity,
    setDetailPageEntityId,
    setIsOpenEvents,
    isMobileScreen,
    regions,
  } = props;

  const [searchValue, setSearchValue] = useState<string>('');
  const [notifications, setNotifications] = useState<
    IGroupedEvents | undefined
  >({});
  const [selectedItem, selectItem] = useState<ILabelValuePair<string> | null>(
    null
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (groupedAllEvents === undefined) setNotifications({});
    if (groupedAllEvents) setNotifications(groupedAllEvents);
  }, [groupedAllEvents]);

  function openOverview(): void {
    dispatch(setShowArtistsOverview());
    setIsOpenEvents(false);
  }

  function getIsNewEvent(eventId: number): boolean {
    const isSameId = (event: IEvent): boolean => event.id === eventId;
    return unreadEvents.events.some(isSameId);
  }

  const handleSearch = ({ target }: any): void => {
    setSearchValue(target.value);
    handleNotifications({
      allEvents: groupedAllEvents,
      selectedItem,
      searchValue: target?.value.trim(),
      setNotifications,
    });
  };

  const select = (item: ILabelValuePair<string>): void => {
    selectItem(item);
    handleNotifications({
      allEvents: groupedAllEvents,
      selectedItem: item,
      searchValue: searchValue?.trim(),
      setNotifications,
    });
  };

  return (
    <>
      <BackButton
        onClick={(evt: MouseEvent): void => {
          evt.stopPropagation();
          setDetailPageEntityId(undefined);
          selectItem(null);
          setSearchValue('');
          setNotifications(groupedAllEvents);
        }}
      >
        <CaretBack />
        &nbsp;&nbsp;Back
      </BackButton>
      <Scroll isMobileScreen={isMobileScreen}>
        <ArtistWrapper>
          <Flex>
            <Artwork src={entity?.thumbnailUrl} entityType="artist" />
            <h2>
              {entity?.displayName ?? '...'}{' '}
              {totalEvents > 0 && <span>({totalEvents})</span>}{' '}
            </h2>

            <Button onClick={openOverview} display="flex" marginLeft="auto">
              <SettingsIcon />
            </Button>
          </Flex>
        </ArtistWrapper>

        <ActivityDropdown select={select} selectedItem={selectedItem} />

        <SearchFieldWrapper mx={4}>
          <SearchField
            handleSearch={handleSearch}
            value={searchValue}
            placeholder="Search for a track"
          />
        </SearchFieldWrapper>

        {notifications && Object.keys(notifications).length > 0 ? (
          Object.entries(notifications).map(([date, events]: any) => (
            <React.Fragment key={date}>
              <TimeHeading>{date}</TimeHeading>
              <AllEventsList
                countries={countries}
                events={events}
                getIsNewEvent={getIsNewEvent}
                regions={regions}
              />
            </React.Fragment>
          ))
        ) : (
          <Box px={4}>
            <NoDataMessage>
              There are no notifications for this artist.
            </NoDataMessage>
          </Box>
        )}
      </Scroll>
    </>
  );
};

interface IProps {
  groupedAllEvents: IGroupedEvents | undefined;
  unreadEvents: IEventData;
  totalEvents: number;
  countries: any[];
  setDetailPageEntityId: (page?: any) => void;
  setIsOpenEvents: (status: boolean) => void;
  entity?: IMetadata;
  isMobileScreen?: boolean;
  regions?: any;
}

export default AllEvents;
